// Time Machine #114 — gate predicate for the header "🕒 Time Travel" button.
//
// Returns true ONLY when the user is logged in AND their Users document's
// `screenAccessList` contains the `"timeMachine"` token.
//
// Access source (#202): managed in ONE place — the "Tab Access" section of
// UserDetailModal, which reads/writes `Users.screenAccessList` (the same array
// that gates the Optimizer/Scheduler/Jobs tabs). This replaced the legacy
// standalone boolean `Users.timeTravelAccess`; a one-time backfill
// (dbtools/src/mutations/access-flags-to-screenaccesslist.mjs) seeded
// `"timeMachine"` into screenAccessList wherever `timeTravelAccess === true`.
// The legacy boolean is now dead data.
//
// Why `.includes(token)` (strict membership): the token is either present or it
// isn't — no truthiness coercion — so a future schema change can't accidentally
// open the gate.

export function canAccessTimeMachine(mongoUser, tsUserDocument) {
  return (
    Boolean(mongoUser) &&
    Array.isArray(tsUserDocument?.screenAccessList) &&
    tsUserDocument.screenAccessList.includes("timeMachine")
  );
}
